<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-4 text-center transaction-card">
        <CardContainer
          ref="card_1"
          :front="front"
          :back="back"
          index="0"
          :class="{ 'dark-mode': darkMode }"
          :isDark="darkMode"
        />
      </div>
      <div class="col-12 col-md-4 text-center transaction-card">
        <CardContainer
          ref="card_2"
          :front="front"
          :back="back"
          index="1"
          :class="{ 'dark-mode': darkMode }"
          :isDark="darkMode"
        />
      </div>
      <div class="col-12 col-md-4 text-center transaction-card">
        <CardContainer
          ref="card_3"
          :front="front"
          :back="back"
          index="2"
          :class="{ 'dark-mode': darkMode }"
          :isDark="darkMode"
        />
      </div>
    </div>
    <div class="row" v-if="showAllCards">
      <div class="col-12 col-md-4 text-center transaction-card">
        <CardContainer
          ref="card_4"
          :front="front"
          :back="back"
          index="3"
          :class="{ 'dark-mode': darkMode }"
          :isDark="darkMode"
        />
      </div>
      <div class="col-12 col-md-4 text-center transaction-card">
        <CardContainer
          ref="card_5"
          :front="front"
          :back="back"
          index="4"
          :class="{ 'dark-mode': darkMode }"
          :isDark="darkMode"
        />
      </div>
      <div class="col-12 col-md-4 text-center transaction-card">
        <CardContainer
          ref="card_6"
          :front="front"
          :back="back"
          index="5"
          :class="{ 'dark-mode': darkMode }"
          :isDark="darkMode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CardContainer from "@/components/CardContainer.vue";
export default {
  components: {
    CardContainer
  },
  props: {
    enableDarkMode: Boolean,
    showAllCards: Boolean,
    stopTimer: Boolean
  },
  data() {
    return {
      darkMode: this.enableDarkMode,
      currentIndex: 0,
      cardRotation: 0,
      nextCard: Number,
      isFlipped: false,
      cardsSet: false,
      timerRunning: false,
      timingFunction: null,
      cardGroups: [
        {
          cardGroupName: "Mergers Acquisitions 1",
          index: 1,
          cards: [
            {
              id: 1,
              image: "../images-transactions/hcp.jpg",
              image_dark: "../images-transactions/hcp-white.png",
              amount: "$6,195,000,000",
              description:
                "Acquisition of real estate assets of HCR ManorCare Inc.",
              role: "Financial Advisor"
            },
            {
              id: 2,
              image: "../images-transactions/holiday.jpg",
              image_dark: "../images-transactions/holiday-white.png",
              amount: "$6,656,981,369",
              description: "Sale to affiliate of Fortress Investments",
              role: "Financial Advisor"
            },
            {
              id: 3,
              image: "../images-transactions/brookdale.jpg",
              image_dark: "../images-transactions/brookdale-white.png",
              amount: "$2,800,000,000",
              description: "Merger with Emeritus Corporation",
              role: "Financial Advisor"
            },
            {
              id: 4,
              image: "../images-transactions/hawthorn.jpg",
              amount: "$2,000,000,000+",
              description: "Sale to Columbia Pacific Advisors",
              role: "Financial Advisor"
            },
            {
              id: 5,
              image: "../images-transactions/griffin-3.jpg",
              amount: "$1,125,000,000",
              description: "Acquisition of Trilogy Health Services",
              role: "Financial Advisor"
            },
            {
              id: 6,
              image: "../images-transactions/northstar-realty.jpg",
              amount: "$4,200,000,000",
              description:
                "Acquisition of real estate assets of Griffin-American Healthcare REIT II",
              role: "Financial Advisor"
            }
          ]
        },
        {
          cardGroupName: "Mergers Acquisitions 2",
          index: 2,
          cards: [
            {
              id: 1,
              image: "../images-transactions/cascade.jpg",
              amount: "$400,000,000+",
              description:
                "Sale of Welltower Leased Portfolio to KKR Controlled Joint Venture",
              role: "Financial Advisor"
            },
            {
              id: 2,
              image: "../images-transactions/brookdale.jpg",
              amount: "$1,125,000,000",
              description: "Strategic Joint Venture with HCP, Inc.",
              role: "Financial Advisor"
            },
            {
              id: 3,
              image: "../images-transactions/broadmark.jpg",
              amount: "$1,380,0000,000",
              description:
                "Merger with Trinity SPAC",
              role: "Financial Advisor"
            },
            {
              id: 4,
              image: "../images-transactions/northstar-healthcare.jpg",
              amount: "$875,000,0000",
              description: "Acquisition of 32 Independent Living Communties",
              role: "Financial Advisor"
            },
            {
              id: 5,
              image: "../images-transactions/aviv.jpg",
              amount: "",
              description: "Roll-Up of Partnerships and Refinancing",
              role: "Financial Advisor"
            },
            {
              id: 6,
              image: "../images-transactions/red-lion.jpg",
              amount: "$27,000,000",
              description:
                "Acquisition of Knights Inn brand from Wyndham Hotel Group",
              role: "Financial Advisor"
            }
          ]
        },
        {
          cardGroupName: "Advisory and Restructuring 1",
          index: 3,
          cards: [
            {
              id: 1,
              image: "../images-transactions/brandywine.jpg",
              image_dark: "../images-transactions/brandywine.png",
              amount: "",
              description:
                "Strategic Advisory & NNN Lease to RIDEA Conversion",
              role: "Financial Advisor"
            },
            {
              id: 2,
              image: "../images-transactions/koelsch.jpg",
              image_dark: "../images-transactions/koelsch.png",
              amount: "",
              description: "Strategic Advisory & NNN Lease Restructuring",
              role: "Financial Advisor"
            },
            {
              id: 3,
              image: "../images-transactions/brookdale.jpg",
              image_dark: "../images-transactions/brookdale-white.png",
              amount: "",
              description: "Lease/RIDEA Restructuring",
              role: "Financial Advisor"
            },
            {
              id: 4,
              image: "../images-transactions/frontier.jpg",
              amount: "",
              description: "Strategic Advisory & Lease Restructuring",
              role: "Financial Advisor"
            },
            {
              id: 5,
              image: "../images-transactions/alg.jpg",
              amount: "",
              description: "Lease Buyout",
              role: "Financial Advisor"
            },
            {
              id: 6,
              image: "../images-transactions/balfour.jpg",
              amount: "",
              description: "Strategic Advisory/Partnership Structuring/Development JV",
              role: "Financial Advisor"
            }
          ]
        },
        {
          cardGroupName: "Advisory and Restructuring 2",
          index: 4,
          cards: [
            {
              id: 1,
              image: "../images-transactions/condor.jpg",
              amount: "",
              description:
                "Debt/Equity Recapitalization",
              role: "Co-Financial Advisor"
            },
            {
              id: 2,
              image: "../images-transactions/ltc.jpg",
              amount: "",
              description: "Lease Re-tenanting / Sale",
              role: "Financial Advisor"
            },
            {
              id: 3,
              image: "../images-transactions/aviv.jpg",
              amount: "",
              description:
                "Roll-up / Recapitalization",
              role: "Financial Advisor"
            },
            {
              id: 4,
              image: "../images-transactions/roic.jpg",
              amount: "",
              description: "SPAC Conversion to REIT",
              role: "Financial Advisor"
            },
            {
              id: 5,
              image: "../images-transactions/trilogy.jpg",
              amount: "",
              description: "Debt Recapitalization",
              role: "Financial Advisor"
            },
            {
              id: 6,
              image: "../images-transactions/epoch.jpg",
              amount: "",
              description:
                "Debt Restructuring",
              role: "Financial Advisor"
            }
          ]
        },
        {
          cardGroupName: "Capital Raising 1",
          index: 5,
          cards: [
            {
              id: 1,
              image: "../images-transactions/omega.jpg",
              image_dark: "../images-transactions/omega-white.png",
              amount: "$100,000,000",
              description: "Common Shares",
              shareprice: "$24.75",
              role: "Lead Placement Agent"
            },
            {
              id: 2,
              image: "../images-transactions/aviv.jpg",
              image_dark: "../images-transactions/aviv-white.png",
              amount: "$303,600,000",
              description: "Common Shares",
              shareprice: "$24.75",
              role: "Co-Manager"
            },
            {
              id: 3,
              image: "../images-transactions/ltc.jpg",
              image_dark: "../images-transactions/ltc-white.png",
              amount: "$48,659,000",
              description: "Common Shares",
              shareprice: "$24.75",
              role: "Lead Placement Agent"
            },
            {
              id: 4,
              image: "../images-transactions/mreic.jpg",
              amount: "$16,780,000",
              description: "Common Shares",
              shareprice: "$24.75",
              role: "Lead Placement Agent"
            },
            {
              id: 5,
              image: "../images-transactions/brookdale.jpg",
              image_dark: "../images-transactions/brookdale-white.png",
              amount: "$300,000,000",
              description: "Common Shares",
              shareprice: "$24.75",
              role: "Co-Manager"
            },
            {
              id: 6,
              image: "../images-transactions/hcp.jpg",
              amount: "$1,273,050,000",
              description: "Common Shares",
              shareprice: "$24.75",
              role: "Co-Manager"
            }
          ]
        },
        {
          cardGroupName: "Capital Raising 2",
          index: 6,
          cards: [
            {
              id: 1,
              image: "../images-transactions/ltc.jpg",
              image_dark: "../images-transactions/ltc-white.png",
              amount: "$62,117,647",
              description: "Preferred Shares",
              shareprice: "$24.75",
              role: "Lead Placement Agent"
            },
            {
              id: 2,
              image: "../images-transactions/omega.jpg",
              image_dark: "../images-transactions/omega-white.png",
              amount: "$118,487,500",
              description: "Preferred Shares",
              shareprice: "$25.00",
              role: "Lead Placement Agent"
            },
            {
              id: 3,
              image: "../images-transactions/tanger.jpg",
              image_dark: "../images-transactions/tanger-white.png",
              amount: "$20,000,000",
              description: "Preferred Shares",
              shareprice: "$25.00",
              role: "Lead Placement Agent"
            },
            {
              id: 4,
              image: "../images-transactions/gladstone.jpg",
              amount: "$30,442,500",
              description: "Preferred Shares",
              shareprice: "$24.75",
              role: "Lead Placement Agent"
            },
            {
              id: 5,
              image: "../images-transactions/umh.jpg",
              amount: "$51,000,000",
              description: "Preferred Shares",
              shareprice: "$25.00",
              role: "Lead Placement Agent"
            },
            {
              id: 6,
              image: "../images-transactions/mreic.jpg",
              amount: "$50,000,000",
              description: "Preferred Shares",
              shareprice: "$25.00",
              role: "Co-Manager"
            }
          ]
        }
      ],
      front: {
        cardGroupName: "",
        index: Number,
        cards: [
          {
            id: Number,
            image: "",
            image_dark: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            image_dark: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            image_dark: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            amount: "",
            description: ""
          }
        ]
      },
      back: {
        cardGroupName: "",
        index: Number,
        cards: [
          {
            id: Number,
            image: "",
            image_dark: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            image_dark: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            image_dark: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            amount: "",
            description: ""
          },
          {
            id: Number,
            image: "",
            amount: "",
            description: ""
          }
        ]
      },
      cardList: []
    };
  },
  methods: {
    setVals() {
      this.front = this.cardGroups[this.currentIndex];
      this.back = this.cardGroups[this.currentIndex + 1];
      if (!this.stopTimer) {
        this.cardTimer();
      }
    },
    setFront() {
      this.front = this.cardGroups[this.currentIndex + 1];
    },
    setBack() {
      this.back = this.cardGroups[this.currentIndex + 1];
    },
    setNewCards(newCardIndex) {
      var comp = this;
      //STOP THE TIMER
      comp.timerRunning = false;
      clearTimeout(comp.timingFunction);
      //INDICATE THAT THE BACK SIDE IS NOW INCORRECT
      comp.cardsSet = false;
      if (comp.currentIndex != newCardIndex) {
        comp.currentIndex = newCardIndex;
        if (comp.isFlipped) {
          comp.front = comp.cardGroups[newCardIndex];
          setTimeout(function() {
            comp.setBack();
          }, 1800);
        } else {
          comp.back = comp.cardGroups[newCardIndex];
          setTimeout(function() {
            comp.setFront();
          }, 1800);
        }
        comp.animateCards();
        if (!comp.stopTimer) {
          setTimeout(function() {
            comp.cardTimer();
          }, 1800);
        }
      }
    },
    animateCards() {
      this.isFlipped = !this.isFlipped;
      var component = this;
      component.cardRotation += 180;
      component.$refs.card_1.$refs.inner.style.transform =
        "rotateY(" + component.cardRotation + "deg)";
      setTimeout(function() {
        component.$refs.card_2.$refs.inner.style.transform =
          "rotateY(" + component.cardRotation + "deg)";
      }, 150);
      setTimeout(function() {
        component.$refs.card_3.$refs.inner.style.transform =
          "rotateY(" + component.cardRotation + "deg)";
      }, 300);
      if (this.showAllCards) {
        setTimeout(function() {
          component.$refs.card_4.$refs.inner.style.transform =
            "rotateY(" + component.cardRotation + "deg)";
        }, 450);
        setTimeout(function() {
          component.$refs.card_5.$refs.inner.style.transform =
            "rotateY(" + component.cardRotation + "deg)";
        }, 600);
        setTimeout(function() {
          component.$refs.card_6.$refs.inner.style.transform =
            "rotateY(" + component.cardRotation + "deg)";
        }, 750);
      }
    },
    cardTimer() {
      var component = this;
      component.timingFunction = setInterval(function() {
        component.animateCards();
      }, 5000);
    }
  },
  mounted() {
    this.setVals();
  }
};
</script>

<style lang="scss">
//Card Styles

.card-container {
  background-color: transparent;
  width: 100%;
  height: 325px;
  perspective: 1000px;
  margin-bottom: 30px;
  &.-flipped .card-inner {
    transform: rotateY(180deg);
  }
  p {
    color: #ffffff;
  }
  &.dark-mode p {
    font-weight: 300;
    color:  #111d3c;
  }
}
.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s ease-in-out;
  transform-style: preserve-3d;
}
.card-front,
.card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  //background-color: rgba(17, 29, 60, 0.8);
  padding: 2rem 1rem;
  border-radius: 20px;
}
.card-back {
  transform: rotateY(180deg);
}
.logo-container {
  height: 100px;
  width: 100%;
  margin-bottom: 1.5rem;
}
h4 {
  font-size: 1.75rem;
}
@media screen and (max-width: 768px) {
  .card-container {
    height: 215px;
  }
  .card-inner {
    border-bottom: 1px solid  #efefef;
  }
  .card-front,
  .card-back {
    padding: 1rem;
  }
  .logo-container {
    margin-bottom: 0.75rem;
  }
  h4 {
    font-size: 1.25rem;
  }
  p {
    line-height: 1.15em;
  }
}
</style>
